module.exports = __webpack_public_path__ + "assets/img/more-btn-df7b7b4b.png";